module.exports = __webpack_public_path__ + "media/customizations/spanishpeaks/back-f277a3a34f9ffd88d25b28e460587588.jpg";